import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { Icon } from '../Icon/Icon';

import styles from './DropZone.module.scss';
import { useFakeProgress } from 'hooks';

interface FakeFile {
    fileURL: string
    fileName: string
}

export type FakeDropZoneProps = {
  className?: string;
  onRemove?: (index: number) => void;
  accept?: string;
  maxSize?: number;
  maxFileCount?: number;
  selectedFiles?: FakeFile[];
  showEye?: boolean;
};

export const FakeDropZone: React.FC<FakeDropZoneProps> = ({ className, accept, maxFileCount, onRemove, ...args }) => {
  if (!maxFileCount) maxFileCount = 1

  const [selectedFiles, setSelectedFiles] = useState<FakeFile[]>([]);
  const { progress } = useFakeProgress();

  useEffect(() => {
    if (args.selectedFiles?.length) setSelectedFiles(args.selectedFiles)
  }, [args.selectedFiles])


  const onFileRemove = (index: number) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
    onRemove && onRemove(index)
  };

  const onEyeClick = (file: FakeFile) => {
    let a = document.createElement('a')
    a.href = file.fileURL
    a.target = '_blank'
    a.click()
  }

  return (
    <div className={clsx(styles.root, className)}>
      {selectedFiles.map((file, i) => (
        <UploadItem onReset={() => onFileRemove(i)} percent={progress} onEyeClick={() => onEyeClick(file)} showEye={args.showEye}>
          {file.fileName}
        </UploadItem>
      ))}
    </div>
  );
};


type UploadItemProps = {
  percent: number;
  onReset: () => void;
  showEye?: boolean;
  onEyeClick?: () => void;
};

const UploadItem: React.FC<UploadItemProps> = ({ percent, children, onReset, onEyeClick, showEye }) => {
  return (
    <div className={clsx(styles['upload-item'], 'mb-2')}>
      <div className={styles.fileName}>{children}</div>
      {percent > 0 && (
        <>
          <div className={styles['progress-value']}>{`${percent} %`}</div>
          <div className={styles.progress} style={{ width: `${percent}%` }} />
        </>
      )}
      {percent === 0 && (
        <>
          <div className={styles.icons}>
            <Icon name="delete" onClick={onReset} />
            {showEye && <Icon name="eye" onClick={onEyeClick} />}
          </div>
        </>
      )}
    </div>
  );
};
